/**
 * BrandLockup — Displays the uploaded MinisRus logo lockup (with "WELLNESS ON THE GO" tagline already inside the image).
 * The logo has a transparent background so it sits cleanly on any surface.
 */
export default function BrandLockup({ size = "sm" }) {
  // Sizes tuned to feel large & vertically centred in the nav bar, and larger on mobile per brief.
  const h = size === "lg"
    ? "h-16 md:h-20"
    : "h-12 sm:h-14 md:h-16";
  return (
    <img
      src="/logo-lockup.png"
      alt="MinisRus — Wellness on the go"
      className={`${h} w-auto block select-none`}
      draggable="false"
    />
  );
}
